import _ from 'lodash';
import {
  SiteEnum,
  ItemEnum,
  FilterEnum,
  AssignEntitiesEnum,
  SiteGroupEnum,
} from 'Common/FieldEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';

export const BASE_URL = '/assignentities';

export const ComponentMapping = {
  SiteToItemsComponents: 'SiteToItemsComponents',
  ItemToSitesComponents: 'ItemToSitesComponents',
  ItemToSiteGroupsComponents: 'ItemToSiteGroupsComponents',
  SiteGroupToItemsComponents: 'SiteGroupToItemsComponents',
  SiteToUsersComponents: 'SiteToUsersComponents',
  UserToSitesComponents: 'UserToSitesComponents',
  UserToSiteGroupsComponents: 'UserToSiteGroupComponents',
  SiteGroupToUsersComponents: 'SiteGroupToUsersComponents',
  SiteToItemsComponentsWithStorageLocation:
    'SiteToItemsComponentsWithStorageLocation',
  SiteGroupToItemsComponentsWithStorageLocation:
    'SiteGroupToItemsComponentsWithStorageLocation',
};

export const SortOptions = [
  { value: AssignEntitiesEnum.Site, label: 'Site' },
  {
    value: AssignEntitiesEnum.SiteGroup,
    label: 'Site Group',
  },
];

export const DropdownOptions = [
  {
    value: AssignEntitiesEnum.FoodItems,
    key: 0,
    text: 'Inventory Items',
  },
  {
    value: AssignEntitiesEnum.Users,
    key: 1,
    text: 'Users',
  },
];

export const getAllowPartialOrderingCheckboxData = data => {
  return data && data.length
    ? data.filter(item => {
        return item[ItemEnum.CheckBox] && item[ItemEnum.AllowPartialOrdering];
      })
    : [];
};
export const reOrderItemList = data => {
  const itemsCopy = _.cloneDeep(data);
  const removedData = _.remove(itemsCopy, item => {
    return item[ItemEnum.CheckBox];
  });
  let sortedData;
  if (removedData.length) {
    sortedData = _.concat(removedData, itemsCopy);
  }
  return sortedData;
};

export const reOrderSiteGroupIds = (allSiteGroupsData, siteGroupIds) => {
  const siteGrpData = _.cloneDeep(allSiteGroupsData);
  const removedData = _.remove(siteGrpData, siteGrp => {
    return siteGroupIds.includes(siteGrp[SiteGroupEnum.Id]);
  });
  let sortedData;
  if (removedData.length) {
    sortedData = _.concat(removedData, siteGrpData);
  }
  return sortedData;
};

export const reOrderSiteGroupList = (allSiteGroupsData, siteGroups) => {
  const siteGrpData = _.cloneDeep(allSiteGroupsData);
  const removedData = _.remove(siteGrpData, siteGrp => {
    return Boolean(
      _.find(siteGroups, sgrp => {
        return siteGrp.Id === sgrp.Id;
      })
    );
  });
  let sortedData;
  if (removedData.length) {
    sortedData = _.concat(removedData, siteGrpData);
  }
  return sortedData;
};

export const reOrderSiteGroupListForStorageLocation = (
  allSiteGroupsData,
  siteGroupsIds
) => {
  const siteGrpData = _.cloneDeep(allSiteGroupsData);
  const removedData = _.remove(siteGrpData, siteGrp => {
    return siteGroupsIds.includes(siteGrp[SiteGroupEnum.Id]);
  });
  let sortedData;
  if (removedData.length) {
    sortedData = _.concat(removedData, siteGrpData);
  }
  return sortedData;
};

export const reOrderSiteList = (allSites, assignedIds) => {
  const sitesData = _.cloneDeep(allSites);
  const removedData = _.remove(sitesData, site => {
    return assignedIds.indexOf(site.Id) > -1;
  });
  let sortedData;
  if (removedData.length) {
    sortedData = _.concat(removedData, sitesData);
  }
  return sortedData;
};

export const reOrderAssignEntitiesSiteIds = (allSites, assignedSitesIds) => {
  const sitesData = _.cloneDeep(allSites);
  const removedData = _.remove(sitesData, site => {
    return assignedSitesIds.includes(site[SiteEnum.Id]);
  });
  let sortedData;
  if (removedData.length) {
    sortedData = _.concat(removedData, sitesData);
  }
  return sortedData;
};

export const reOrderAssignEntitiesSiteList = (allSites, assignedSites) => {
  const sitesData = _.cloneDeep(allSites);
  const removedData = _.remove(sitesData, site => {
    return _.find(assignedSites, assignedSite => {
      return assignedSite[SiteEnum.Id] === site[SiteEnum.Id];
    });
  });
  let sortedData;
  if (removedData.length) {
    sortedData = _.concat(removedData, sitesData);
  }
  return sortedData;
};

export const getComponentOnSelection = (listByVal, optionVal, direction) => {
  if (
    listByVal === AssignEntitiesEnum.Site &&
    optionVal === AssignEntitiesEnum.FoodItems
  ) {
    return direction
      ? ComponentMapping.SiteToItemsComponents
      : ComponentMapping.ItemToSitesComponents;
  } else if (
    listByVal === AssignEntitiesEnum.SiteGroup &&
    optionVal === AssignEntitiesEnum.FoodItems
  ) {
    return direction
      ? ComponentMapping.SiteGroupToItemsComponents
      : ComponentMapping.ItemToSiteGroupsComponents;
  } else if (
    listByVal === AssignEntitiesEnum.Site &&
    optionVal === AssignEntitiesEnum.Users
  ) {
    return direction
      ? ComponentMapping.SiteToUsersComponents
      : ComponentMapping.UserToSitesComponents;
  } else if (
    listByVal === AssignEntitiesEnum.SiteGroup &&
    optionVal === AssignEntitiesEnum.Users
  ) {
    return direction
      ? ComponentMapping.SiteGroupToUsersComponents
      : ComponentMapping.UserToSiteGroupsComponents;
  }
};

export const updateRowCheckBox = (
  data,
  columnName,
  checkBoxValue,
  isHeaderLevelAllowOrderingSite
) => {
  const dataCopy = _.cloneDeep(data);
  if (
    dataCopy[ItemEnum.AllowPartialOrdering] &&
    dataCopy[ItemEnum.CheckBox] &&
    isHeaderLevelAllowOrderingSite
  ) {
    dataCopy[ItemEnum.AllowPartialOrderingSite] = checkBoxValue;
    return dataCopy;
  }
  if (columnName === ItemEnum.VendorOnly) {
    if (checkBoxValue) {
      dataCopy[ItemEnum.VendorOnly] = checkBoxValue;
      dataCopy[ItemEnum.VendorAllowed] = checkBoxValue;
      dataCopy[ItemEnum.CheckBox] = checkBoxValue;
    } else if (!checkBoxValue) {
      dataCopy[ItemEnum.VendorOnly] = checkBoxValue;
    }
  } else if (columnName === ItemEnum.VendorAllowed) {
    if (checkBoxValue) {
      dataCopy[ItemEnum.VendorAllowed] = checkBoxValue;
      dataCopy[ItemEnum.CheckBox] = checkBoxValue;
    } else if (!checkBoxValue) {
      dataCopy[ItemEnum.VendorOnly] = checkBoxValue;
      dataCopy[ItemEnum.VendorAllowed] = checkBoxValue;
    }
  } else if (columnName === ItemEnum.CheckBox) {
    if (dataCopy[ItemEnum.AllowPartialOrdering]) {
      dataCopy[ItemEnum.AllowPartialOrderingSite] = checkBoxValue;
    }
    if (checkBoxValue) {
      dataCopy[ItemEnum.CheckBox] = checkBoxValue;
    } else if (!checkBoxValue) {
      dataCopy[ItemEnum.VendorOnly] = checkBoxValue;
      dataCopy[ItemEnum.CheckBox] = checkBoxValue;
      dataCopy[ItemEnum.VendorAllowed] = checkBoxValue;
    }
  }
  return dataCopy;
};

export const getAssignEntitiesURL = assignAction => {
  let URL = 'AssignEntities/';
  switch (assignAction) {
    case ComponentMapping.SiteToItemsComponents:
      URL += 'WriteItemsToSite';
      break;
    case ComponentMapping.SiteToUsersComponents:
      URL += 'WriteUsersToSite';
      break;
    case ComponentMapping.SiteGroupToItemsComponents:
      URL += 'WriteItemsToSiteGroup';
      break;
    case ComponentMapping.SiteGroupToUsersComponents:
      URL += 'WriteUsersToSiteGroup';
      break;
    case ComponentMapping.ItemToSitesComponents:
      URL += 'WriteSitesToItem';
      break;
    case ComponentMapping.ItemToSiteGroupsComponents:
      URL += 'WriteSiteGroupsToItem';
      break;
    case ComponentMapping.UserToSitesComponents:
      URL += 'WriteSitesToUser';
      break;
    case ComponentMapping.UserToSiteGroupsComponents:
      URL += 'WriteSiteGroupsToUser';
      break;
    case ComponentMapping.SiteToItemsComponentsWithStorageLocation:
      URL += 'WriteSiteItemToStorageLocation';
      break;
    case ComponentMapping.SiteGroupToItemsComponentsWithStorageLocation:
      URL += 'WriteSiteGrpItemToStorageLocation';
      break;
    default:
      URL += 'WriteItemsToSite';
      break;
  }
  return URL;
};

export const makePayload = gridInfo => {
  const gridInfoClone = _.cloneDeep(gridInfo);
  const payload = [];
  gridInfoClone.forEach(siteOrSiteGroup => {
    if (siteOrSiteGroup[SiteEnum.CheckBox]) {
      payload.push({
        Id: siteOrSiteGroup.Id,
        [SiteEnum.MaximumParLevel]: siteOrSiteGroup[SiteEnum.MaximumParLevel]
          ? siteOrSiteGroup[SiteEnum.MaximumParLevel]
          : null,
        [SiteEnum.MinimumParLevel]: siteOrSiteGroup[SiteEnum.MinimumParLevel]
          ? siteOrSiteGroup[SiteEnum.MinimumParLevel]
          : null,
      });
    }
  });
  return payload;
};

export const getCheckedData = (data, columnName) => {
  return data && data.length
    ? data.filter(item => {
        return item[columnName];
      })
    : [];
};

export const getCheckedRefData = (data, columnName) => {
  let filteredData = [];
  if (data && data.length) {
    data.forEach(item => {
      item._original[columnName] && filteredData.push(item._original);
    });
  }
  return filteredData;
};

export const getPayload = (values, renderedComponent) => {
  const {
    ItemGridInfo,
    SiteGridInfo,
    SiteGroupGridInfo,
    UserGridInfo,
    GroupId_Location,
  } = values;
  let payload = null;
  switch (renderedComponent) {
    case ComponentMapping.SiteToItemsComponents:
      payload = {
        Id: SiteGridInfo[0],
        ItemsToSite: getCheckedData(ItemGridInfo, ItemEnum.CheckBox),
      };
      break;
    case ComponentMapping.SiteToUsersComponents:
      payload = {
        Id: SiteGridInfo[0],
        UserName: UserGridInfo,
      };
      break;
    case ComponentMapping.SiteGroupToItemsComponents:
      payload = {
        SiteGroup: SiteGroupGridInfo[0],
        Items: getCheckedData(ItemGridInfo, ItemEnum.CheckBox),
      };
      break;
    case ComponentMapping.SiteGroupToUsersComponents:
      payload = {
        SiteGroup: SiteGroupGridInfo[0],
        UserNames: UserGridInfo,
      };
      break;
    case ComponentMapping.ItemToSitesComponents:
      payload = {
        Item: ItemGridInfo[0],
        Sites: makePayload(SiteGridInfo),
      };
      break;
    case ComponentMapping.ItemToSiteGroupsComponents:
      payload = {
        Item: ItemGridInfo[0],
        SiteGroups: makePayload(SiteGroupGridInfo),
      };
      break;
    case ComponentMapping.UserToSitesComponents:
      payload = {
        UserName: UserGridInfo[0],
        Sites: SiteGridInfo,
      };
      break;
    case ComponentMapping.UserToSiteGroupsComponents:
      payload = {
        UserName: UserGridInfo[0],
        SiteGroups: SiteGroupGridInfo,
      };
      break;

    case ComponentMapping.SiteToItemsComponentsWithStorageLocation:
      payload = {
        Id: ItemGridInfo,
        Sites: SiteGridInfo,
        StorageLocationId: GroupId_Location,
      };
      break;

    case ComponentMapping.SiteGroupToItemsComponentsWithStorageLocation:
      payload = {
        Id: ItemGridInfo,
        SitesGroups: SiteGroupGridInfo,
        StorageLocationId: GroupId_Location,
      };
      break;
    default:
      payload = null;
  }
  return payload;
};

export const validateStorageLocationForm = values => {
  const errors = {};

  if (
    !values[FilterEnum.GroupId_Location] ||
    !_.trim(values[FilterEnum.GroupId_Location]).length
  ) {
    errors[FilterEnum.GroupId_Location] =
      'Storage Location is required! Please select storage Location.';
  }
  return errors;
};

export const reOrderStorageLocationItems = (itemsIds, allItemsData) => {
  const allItemsDataCopy = _.cloneDeep(allItemsData);
  const removedIds = _.remove(allItemsDataCopy, item => {
    return itemsIds.indexOf(item.ItemId) > -1;
  });
  let allSortedItems;
  if (removedIds.length) {
    allSortedItems = _.concat(removedIds, allItemsDataCopy);
  }
  return allSortedItems;
};

export const getOrderPreferenceId = (allSitesData, SiteGridInfo) => {
  return _.find(allSitesData, site => {
    return site[SiteEnum.Id] === SiteGridInfo[0];
  });
};

export const reOrderUserList = (allUsers, selectedUserName) => {
  const allUsersCopy = _.cloneDeep(allUsers);
  const removedData = _.remove(allUsersCopy, user => {
    return selectedUserName.indexOf(user.UserName) > -1;
  });
  let sortedData;
  if (removedData.length) {
    sortedData = _.concat(removedData, allUsersCopy);
  }
  return sortedData;
};

export const minMaxValidation = (
  SiteGridInfo,
  SiteGroupGridInfo,
  ItemGridInfo,
  renderedComponent
) => {
  if (
    renderedComponent === ComponentMapping.ItemToSitesComponents &&
    SiteGridInfo.length
  ) {
    return SiteGridInfo.some(site => {
      if (site[SiteEnum.CheckBox]) {
        return (
          +site[SiteEnum.MinimumParLevel] > +site[SiteEnum.MaximumParLevel]
        );
      }
      return false;
    });
  } else if (
    renderedComponent === ComponentMapping.ItemToSiteGroupsComponents &&
    SiteGroupGridInfo.length
  ) {
    return SiteGroupGridInfo.some(siteGroup => {
      if (siteGroup[SiteGroupEnum.CheckBox]) {
        return (
          +siteGroup[SiteGroupEnum.MinimumParLevel] >
          +siteGroup[SiteGroupEnum.MaximumParLevel]
        );
      }
      return false;
    });
  } else if (
    (renderedComponent === ComponentMapping.SiteToItemsComponents ||
      renderedComponent === ComponentMapping.SiteGroupToItemsComponents) &&
    ItemGridInfo.length
  ) {
    return ItemGridInfo.some(item => {
      if (item[ItemEnum.CheckBox]) {
        return (
          +item[ItemEnum.MinimumParLevel] > +item[ItemEnum.MaximumParLevel]
        );
      }
      return false;
    });
  } else {
    return false;
  }
};

export const checkVisibilityForSiteUser = props => {
  const { isRightSideSiteGrid, isLeftSideUserGrid } = props;
  if (isRightSideSiteGrid && isLeftSideUserGrid) {
    return false;
  } else if (isRightSideSiteGrid) {
    return true;
  }
  return false;
};

export const checkVisibilityForSiteGroupUser = props => {
  const { isRightSideSiteGroupGrid, isLeftSideUserGrid } = props;
  if (isRightSideSiteGroupGrid && isLeftSideUserGrid) {
    return false;
  } else if (isRightSideSiteGroupGrid) {
    return true;
  }
  return false;
};

export const callApiBasedOnRenderComponent = (
  props,
  renderedComponent,
  onResetPageOnDataChange
) => {
  switch (renderedComponent) {
    case ComponentMapping.SiteToItemsComponents:
      props.getItemsBySiteId(props[AssignEntitiesEnum.SiteGridInfo][0]);
      onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Site]: false,
        [GridNames.Item]: true,
      });
      break;

    case ComponentMapping.SiteGroupToItemsComponents:
      props.getItemsBySiteGroupId(
        props[AssignEntitiesEnum.SiteGroupGridInfo][0]
      );
      onResetPageOnDataChange(GridResetInitialValueEnum);
      break;

    case ComponentMapping.SiteToUsersComponents:
      props.getUsersBySiteId(props[AssignEntitiesEnum.SiteGridInfo][0]);
      onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Site]: false,
        [GridNames.User]: true,
      });
      break;

    case ComponentMapping.SiteGroupToUsersComponents:
      props.getUsersBySiteGroupId(
        props[AssignEntitiesEnum.SiteGroupGridInfo][0]
      );
      onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.User]: true,
      });
      break;

    case ComponentMapping.ItemToSitesComponents:
      props.getSitesByItemId(props[AssignEntitiesEnum.ItemGridInfo][0]);
      onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Item]: false,
        [GridNames.Site]: true,
      });
      break;

    case ComponentMapping.UserToSitesComponents:
      props.getSitesByUserName(props[AssignEntitiesEnum.UserGridInfo][0]);
      onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.User]: false,
        [GridNames.Site]: true,
      });
      break;

    case ComponentMapping.UserToSiteGroupsComponents:
      props.getSiteGroupsByUserName(props[AssignEntitiesEnum.UserGridInfo][0]);
      onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.User]: false,
      });
      break;

    case ComponentMapping.ItemToSiteGroupsComponents:
      props.getSiteGroupByItemId(props[AssignEntitiesEnum.ItemGridInfo][0]);
      onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Item]: false,
      });
      break;

    case ComponentMapping.SiteToItemsComponentsWithStorageLocation:
    case ComponentMapping.SiteGroupToItemsComponentsWithStorageLocation:
      props.getSiteSiteGrpItemByStorageLoc(props.storageLocationValue);
      onResetPageOnDataChange({
        ...GridResetInitialValueEnum,
        [GridNames.Item]: true,
        [GridNames.Site]: true,
      });
      break;

    default:
      return;
  }
};

export const AssignEntitiesUserGridEnum = {
  UserName: 'UserName',
};

export const getFilteredIds = (sortedData, columnName) => {
  return sortedData.map(item => {
    return item[columnName] ? item[columnName] : item._original[columnName];
  });
};

export const getCheckedUserGridData = (sortedData, userGridInfo) => {
  //find sortedData intersection with UserGridInfo
  const sortedDataUserNames = getFilteredIds(
    sortedData,
    AssignEntitiesUserGridEnum.UserName
  );

  return _.intersection(userGridInfo, sortedDataUserNames);
};

export const getCheckedGridData = (sortedData, gridInfo, columnName) => {
  const Ids = sortedData.map(item => {
    return item[columnName] ? item[columnName] : item._original[columnName];
  });
  return _.intersection(gridInfo, Ids);
};

export const getGridInitialValues = (
  renderedComponent,
  allFormValues,
  reducerInitialValues
) => {
  let leftGridData, rightGridData;
  switch (renderedComponent) {
    case ComponentMapping.SiteToItemsComponents:
      leftGridData = {
        name: AssignEntitiesEnum.SiteGridInfo,
        value: allFormValues[AssignEntitiesEnum.SiteGridInfo],
      };
      rightGridData = {
        name: AssignEntitiesEnum.ItemGridInfo,
        value: reducerInitialValues.itemsBySiteId,
      };
      break;

    case ComponentMapping.SiteGroupToItemsComponents:
      leftGridData = {
        name: AssignEntitiesEnum.SiteGroupGridInfo,
        value: allFormValues[AssignEntitiesEnum.SiteGroupGridInfo],
      };
      rightGridData = {
        name: AssignEntitiesEnum.ItemGridInfo,
        value: reducerInitialValues.itemsBySiteGroupId,
      };
      break;

    case ComponentMapping.SiteToUsersComponents:
      leftGridData = {
        name: AssignEntitiesEnum.SiteGridInfo,
        value: allFormValues[AssignEntitiesEnum.SiteGridInfo],
      };
      rightGridData = {
        name: AssignEntitiesEnum.UserGridInfo,
        value: reducerInitialValues.usersBySiteId,
      };
      break;

    case ComponentMapping.SiteGroupToUsersComponents:
      leftGridData = {
        name: AssignEntitiesEnum.SiteGroupGridInfo,
        value: allFormValues[AssignEntitiesEnum.SiteGroupGridInfo],
      };
      rightGridData = {
        name: AssignEntitiesEnum.UserGridInfo,
        value: reducerInitialValues.usersBySiteGroupId,
      };
      break;

    case ComponentMapping.ItemToSitesComponents:
      leftGridData = {
        name: AssignEntitiesEnum.ItemGridInfo,
        value: allFormValues[AssignEntitiesEnum.ItemGridInfo],
      };
      rightGridData = {
        name: AssignEntitiesEnum.SiteGridInfo,
        value: reducerInitialValues.sitesByItemId,
      };
      break;

    case ComponentMapping.UserToSitesComponents:
      leftGridData = {
        name: AssignEntitiesEnum.UserGridInfo,
        value: allFormValues[AssignEntitiesEnum.UserGridInfo],
      };
      rightGridData = {
        name: AssignEntitiesEnum.SiteGridInfo,
        value: reducerInitialValues.sitesByUserName,
      };
      break;

    case ComponentMapping.UserToSiteGroupsComponents:
      leftGridData = {
        name: AssignEntitiesEnum.UserGridInfo,
        value: allFormValues[AssignEntitiesEnum.UserGridInfo],
      };
      rightGridData = {
        name: AssignEntitiesEnum.SiteGroupGridInfo,
        value: reducerInitialValues.siteGroupsByUserName,
      };
      break;

    case ComponentMapping.ItemToSiteGroupsComponents:
      leftGridData = {
        name: AssignEntitiesEnum.ItemGridInfo,
        value: allFormValues[AssignEntitiesEnum.ItemGridInfo],
      };
      rightGridData = {
        name: AssignEntitiesEnum.SiteGroupGridInfo,
        value: reducerInitialValues.siteGroupsByItemId,
      };
      break;

    default:
      break;
  } //end of switch case

  return {
    leftGridData,
    rightGridData,
  };
};

export const GridNames = {
  SiteGroup: 'SiteGroup',
  Item: 'Item',
  User: 'User',
  Site: 'Site',
};
export const GridResetInitialValueEnum = {
  [GridNames.SiteGroup]: true,
  [GridNames.Item]: true,
  [GridNames.User]: true,
  [GridNames.Site]: true,
};

export const INITIAL_VALUES = {
  To: AssignEntitiesEnum.FoodItems,
  SortOptions: AssignEntitiesEnum.Site,
  SiteGridInfo: [],
  ItemGridInfo: [],
  SiteGroupGridInfo: [],
  UserGridInfo: [],
  [FilterEnum.GroupId_Cat]: GenericEnum.InitialFilterValue,
  [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
  [FilterEnum.GroupId_Bid]: GenericEnum.InitialFilterValue,
  [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
  [FilterEnum.GroupId_Location]: GenericEnum.InitialFilterValue,
  [FilterEnum.PrepareInHouse]: false,
};



// WEBPACK FOOTER //
// ./src/pages/utilities/helper/assignEntities.js